// extracted by mini-css-extract-plugin
export default {"root":"ExpertBadge_root__FMnsK","content":"ExpertBadge_content__VaZAi"};